<div class="group-enrollment">
  <div *ngIf="!group.studentsCount && currentView === 'menu'">
    <div class="main__void">
      <div class="main__void--icon">
        <span class="glicon-student"></span>
      </div>
      <span class="main__void--title">{{ 'students.notStudentsGroup' | translate }}</span>
      <span class="main__void--subtitle">{{ 'students.newStudentsAddGroup' | translate }}</span>
      <ng-container *ngTemplateOutlet="enrollStudentsButton"></ng-container>
    </div>
  </div>

  <div *ngIf="group.studentsCount > 0 && currentView === 'menu'">
    <lms-group-licenses [group]="group" [course]="course">
      <div class="lms-toolbar__item" tools-actions>
        <ng-container *ngTemplateOutlet="enrollStudentsButton"></ng-container>
      </div>
    </lms-group-licenses>
  </div>

  <div id="read" class="tabs-content" *ngIf="currentView === 'invite'">
    <div class="row">
      <div>
        <lms-dynamic-form
          [options]="{ submitLabel: 'actions.saveChanges' }"
          [action]="'groups.enrollment.self.edit'"
          [title]="'nouns.selfRegistrationUrl'"
          [questionsService]="questionsService"
          [data]="data"
          (submit)="updateSelfRegistrationConfig($event)"
        >
          <ng-content select="[form-actions-before]" form-actions-before> </ng-content>
          <gl-button
            color-secondary
            [text]="'actions.cancel' | translate"
            (onClick)="setView('menu')"
            form-actions-before
          ></gl-button>
        </lms-dynamic-form>
      </div>
    </div>
  </div>

  <div id="select" class="tabs-content" *ngIf="currentView === 'select'">
    <div class="row">
      <div>
        <lms-toolbar
          [options]="{ list: { listId: clientStudentslistId, filterRow: true, columnChooser: false, skeletor: true } }"
        >
          <div class="lms-toolbar__item padding-none" left>
            <gl-checkbox
              id="reEnrolled"
              small
              [label]="'students.import.reEnrolledLabel' | translate"
              skeletorValueAccessor
              checked
              (onChange)="setStudentsSelectionOptions($event.detail.value)"
            >
            </gl-checkbox>
          </div>
          <div class="lms-toolbar__item">
            <gl-button
              color-secondary
              small
              [text]="'actions.cancel' | translate"
              (onClick)="setView('menu')"
              form-actions-before
            >
            </gl-button>
          </div>
        </lms-toolbar>
        <lms-students-list
          [enrollmentGroup]="group"
          [listId]="clientStudentslistId"
          [selectable]="true"
          [options]="studentsSelectionOptions"
          (onEnroll)="onEnrollStudents($event)"
        ></lms-students-list>
      </div>
    </div>
  </div>

  <div id="import" class="tabs-content" *ngIf="currentView === 'copy'">
    <div class="row">
      <div>
        <lms-group-students-import [group]="group" (onEnroll)="onEnrollStudents($event)"> </lms-group-students-import>
      </div>
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="setView('menu')"
        form-actions-before
      ></gl-button>
    </div>
  </div>

  <div id="add" class="tabs-content" *ngIf="currentView === 'add'">
    <lms-license-editor (onSave)="onLicensesCreated({ created: 1 })">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="setView('menu')" form-actions-before>
      </gl-button>
    </lms-license-editor>
  </div>
</div>

<lms-modal #modalCsvUpload size="medium">
  <lms-csv-import
    #downloadcCsvExample
    [isGroup]="true"
    (closeModal)="closeCsvModal()"
    (onSaveCsvData)="onSaveCsv($event)"
  ></lms-csv-import>
</lms-modal>

<!-- enroll students button -->
<ng-template #enrollStudentsButton>
  <lms-button-select
    *lmsProfileGuard="'groups.enroll'"
    [id]="'enrollment'"
    [isDisabled]="
      bonusStudentLimitReached || isGroupExpired || isCourseWithdrawn || isCourseArchived || !canAddNewStudents
    "
    [title]="'groups.wizard.enrollStudents'"
    [text]="'students.add'"
    [tooltip]="
      !canAddNewStudents
        ? 'students.subscriptionCheck.noActiveSubscription'
        : bonusStudentLimitReached
        ? 'students.noEnrollBonusLimitTooltip'
        : isGroupExpired
        ? 'students.groupExpiredTooltip'
        : isCourseWithdrawn || isCourseArchived
        ? 'students.noCourseAvailableTooltip'
        : ''
    "
    [tooltipLeft]="group.studentsCount > 0"
  >
    <li *ngIf="canAddNewStudents && isSeatsAvailable">
      <a (click)="setView('invite')">{{ 'groups.enrollment.list.inviteStudentButton' | translate }}</a>
    </li>
    <li>
      <a (click)="setView('select')">{{ 'groups.enrollment.list.selectStudentButton' | translate }}</a>
    </li>
    <li *ngIf="isSeatsAvailable">
      <a (click)="setView('copy')">{{ 'groups.enrollment.list.copyStudentButton' | translate }}</a>
    </li>
    <li *ngIf="canAddNewStudents && isSeatsAvailable">
      <a (click)="setView('add')">{{ 'groups.enrollment.list.addStudentButton' | translate }}</a>
    </li>
    <div *ngIf="isSeatsAvailable">
      <li *lmsProfileGuard="'students.importCsv'">
        <a (click)="openCsvModal()">{{ 'students.addCsv' | translate }}</a>
      </li>
    </div>
  </lms-button-select>
</ng-template>
